import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('HowYouLearn_Parent'),
			accessor: 'fullName',
			cell: (fullName, row) => (<Link to={`/parents/${row.id}`} > {fullName}</Link>),
			sortable: true
		},
		{
			header: t('HowYouLearn_RegistrationDate'),
			accessor: 'created',
			cell: (created) => (ui.formatDateTime(created)),
			sortable: true
		},
		{
			header: t('HowYouLearn_Address'),
			accessor: 'address',
			sortable: true
		},	
		{
			header: t('HowYouLearn_PhoneNumber'),
			accessor: 'phoneNumber',
			sortable: true
		},	
		{
			header: t('HowYouLearn_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('HowYouLearn_HowYouLearn'),
			accessor: 'referralSource',
			cell: (referralSource, row) => t(`ReferralSourceType_${referralSource.name}`) + (referralSource.name == 'Other' ? ": " + row.howYouLearn : ""),
			sortable: false
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);